/**
 * Same labels as LabelGeneratorFormContent — split by packaging family so shared
 * values (e.g. 375, 330.6) resolve correctly.
 */
const SLAB = {
  '24x.440': '24 x 440ml Cans',
  440.12: '12 x 440ml Cans',
  '15x.440': '15 x 440ml Cans',
  '16x.440': '16 x 440ml Cans',
  440.4: '440ml Cans (6 x 4-packs)',
  375: '375ml Cans',
  330.12: '330ml Cans (2 x 12-packs)',
  '330.10': '330ml Cans (3 x 10-packs)',
  330.6: '330ml Cans (4 x 6-packs)',
  330.4: '330ml Cans (6 x 4-packs)',
  '24x.330': '24 x 330ml Cans',
  '16x.330': '16 x 330ml Cans',
  250.4: '250ml Cans (6 x 4-packs)',
  250: '250ml Cans',
};

const CASE = {
  750.12: '750ml Bottles (Crushed 12-pack)',
  750: '750ml Bottles',
  650: '650ml Bottles',
  375.6: '375ml Bottles (4 x 6-packs)',
  375: '375ml Bottles',
  330.6: '330ml Bottles (4 x 6-packs)',
  330: '330ml Bottles',
};

const KEG = {
  50: '50L',
  30: '30L',
  20: '20L',
  19.5: '19.5L',
};

/**
 * @param {string} unitSize
 * @param {'slab'|'case'|'keg'|undefined} packagingType
 */
export default function labelUnitSizeDisplay(unitSize, packagingType) {
  if (unitSize == null || unitSize === '') return '';
  const key = String(unitSize);
  if (packagingType === 'slab') return SLAB[key] ?? SLAB[unitSize] ?? key;
  if (packagingType === 'case') return CASE[key] ?? CASE[unitSize] ?? key;
  if (packagingType === 'keg') return KEG[key] ?? KEG[unitSize] ?? key;
  return key;
}
